import type { ShiftInfo } from "@dexteel/mesf-core";
import moment from "moment";

/**
 * Id of the shift (among those `shift` already knows: current, previous, next
 * and the live one) whose [Start, End) contains `at`, or 0 if none does.
 *
 * Use it to show the shift of a timestamp: [MES].[GetShiftByParameters] takes a
 * production DATE, so passing a timestamp after midnight UTC lands on the next
 * production day's shift (a night-shift save jumped to the empty day shift).
 */
export const shiftIdContaining = (
  shift: ShiftInfo | null | undefined,
  at: Date | null | undefined,
): number => {
  if (!shift || !at) return 0;
  const t = moment(at).valueOf();
  const candidates: [number | null, unknown, unknown][] = [
    [shift.CurrentShiftId, shift.CurrentStart, shift.CurrentEnd],
    [shift.PreviousShiftId, shift.PreviousStart, shift.PreviousEnd],
    [shift.NextShiftId, shift.NextStart, shift.NextEnd],
    [shift.LastShiftId, shift.LastStart, shift.LastEnd],
  ];
  for (const [id, start, end] of candidates) {
    if (!id || !start || !end) continue;
    // Raw API values are UTC without an offset; Dates are already absolute
    if (
      moment.utc(start as Date).valueOf() <= t &&
      t < moment.utc(end as Date).valueOf()
    )
      return id;
  }
  return 0;
};
